module.exports = __webpack_public_path__ + "media/images/lp/fig_guide_03-1359e6a9beee8b649ef5410f142d720b.png";